import React, { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import Modal from 'react-bootstrap/Modal';
import CustomHead from '../../../components/common/head/Head';
import { apiUrl, baseUrl } from '../../../config/apiConfig';
import axios from 'axios';
import { metaSiteTitle } from '../../../config/defaultMetaConfig';
import Link from 'next/link';
import { useForm } from 'react-hook-form';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserAlt } from '@fortawesome/free-solid-svg-icons';
import { patterns } from '../../../constants/patterns';
import { GoogleReCaptchaProvider, GoogleReCaptcha } from 'react-google-recaptcha-v3';
import { googleCaptchaSiteKey } from '../../../config/appConfig';
import { useRouter } from 'next/router';
import Custom404 from '../../_error';

import JobJsonLd from '../../../components/pages/job/JobJsonLd';
import { toast } from 'react-toastify';

const HeroArea = dynamic(() => import('../../../components/pages/job/HeroArea'), {
	loading: () => {
		return '';
	},
	ssr: false,
});
const JobInformation = dynamic(() => import('../../../components/pages/job/JobInformation'), {
	loading: () => {
		return '';
	},
	ssr: false,
});
const JobDescription = dynamic(() => import('../../../components/pages/job/JobDescription'), {
	loading: () => {
		return '';
	},
	ssr: false,
});

const JobDetailsPage = ({ siteSetting, jobDetails }) => {
	// console.log("siteSetting", siteSetting);
	// console.log("jobDetails", jobDetails);

	const [show, setShow] = useState(false);
	const [googleCaptchaValue, setGoogleCaptchaValue] = useState('');

	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm({
		mode: 'onChange',
	});
	const alert = toast;

	const router = useRouter();

	useEffect(() => {
		let mounted = true;

		if (mounted) {
		}
		return () => {
			mounted = false;
		};
	}, [router, jobDetails]);

	if (!jobDetails) {
		return <Custom404 />;
	}

	// console.log("jobdetails",jobDetails.id);

	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);

	const handleJobApplySubmit = (formData, e) => {
		// console.log("formData", formData);
		// return false;

		if (googleCaptchaValue) {
			const bodyFormData = new FormData();
			bodyFormData.append('captchaResponse', googleCaptchaValue);
			bodyFormData.append('job_id', jobDetails.id);
			bodyFormData.append('email', formData.email ? formData.email : '');
			bodyFormData.append('name', formData.name ? formData.name : '');
			bodyFormData.append('phone_number', formData.phone ? formData.phone : '');
			bodyFormData.append('cvFile', formData.file && formData.file.length > 0 ? formData.file[0] : '');

			axios
				.post(apiUrl + '/api/applyJob', bodyFormData)
				.then((response) => {
					// console.log(response);
					if (response && response.data && response.data.data) {
						alert.success(response.data.data);
					} else {
						alert.error('Captcha Invalid! Please refresh the page.');
					}
				})
				.catch(function (error) {
					// console.log(error.response);
					alert.error(error.response.data.msg);
				});
		} else {
			alert.error('Captcha Required!');
		}
	};

	const handleCaptchaChange = (token) => {
		// console.log("Captcha value:", token);
		setGoogleCaptchaValue(token);
	};

	return (
		<>
			<CustomHead
				title={
					(jobDetails && jobDetails.title ? jobDetails.title : 'Job Details') +
					' | ' +
					(siteSetting && siteSetting.title ? siteSetting.title : metaSiteTitle)
				}
				metaTitle={jobDetails && jobDetails.title ? jobDetails.title : 'Job Details'}
				description={jobDetails && jobDetails.sub_title ? jobDetails.sub_title : ''}
				url={jobDetails && jobDetails.slug ? baseUrl + '/job/' + jobDetails.slug : ''}
				image={jobDetails && jobDetails.image ? apiUrl + jobDetails.image : ''}
				type={'article'}
			>
				<JobJsonLd jobDetails={jobDetails} />
			</CustomHead>
			<div className="page-area job-page-area mh-80v">
				<HeroArea handleShow={handleShow} jobDetails={jobDetails} />
				<JobInformation jobDetails={jobDetails} />
				<JobDescription jobDetails={jobDetails} />

				<div className="job-apply-links d-flex justify-content-center align-items-center mt-2 pb-5">
					<button
						type="button"
						className="fs-18 lh-40 btn-gradient btn-gradient-blue-light-blue position-relative hover overflow-hidden text-white px-4 py-2 radius-12 d-inline-flex"
						onClick={handleShow}
					>
						<span className="text">Apply Now</span>
					</button>
					<Link
						href="/careers"
						className="fs-18 lh-40 btn-gradient btn-gradient-black-silver position-relative hover overflow-hidden text-white px-4 py-2 radius-12 d-inline-flex ms-2"
					>
						<span className="text">Cancel</span>
					</Link>
				</div>

				<Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} centered>
					<Modal.Header closeButton>
						<Modal.Title>{jobDetails && jobDetails.title ? jobDetails.title : 'Job Details'}</Modal.Title>
					</Modal.Header>
					<GoogleReCaptchaProvider reCaptchaKey={googleCaptchaSiteKey}>
						<form onSubmit={handleSubmit(handleJobApplySubmit)}>
							<Modal.Body>
								<div className="job-apply-form-body">
									<div className="form-group mb-3">
										<label htmlFor="name" className="fw-semibold">
											Name:
										</label>
										<input
											type="text"
											className="form-control"
											placeholder="Enter your name"
											{...register('name', {
												required: 'Name is required',
											})}
										/>
										{errors.name && <div className="form-error-message">{errors.name.message}</div>}
									</div>
									<div className="form-group mb-3">
										<label htmlFor="email" className="fw-semibold">
											Email:
										</label>
										<input
											type="email"
											className="form-control"
											placeholder="Enter your email"
											{...register('email', {
												required: 'Email is required',
												pattern: {
													value: patterns.emailPattern,
													message: 'Enter a valid email',
												},
											})}
										/>
										{errors.email && <div className="form-error-message">{errors.email.message}</div>}
									</div>
									<div className="form-group mb-3">
										<label htmlFor="phone" className="fw-semibold">
											Phone:
										</label>
										<input
											type="text"
											placeholder="Enter your phone number"
											className="form-control"
											{...register('phone', {
												required: 'Phone number is required',
												pattern: {
													value: /^[0-9]+$/i,
													message: 'Please enter a number',
												},
											})}
										/>
										{errors.phone && <div className="form-error-message">{errors.phone.message}</div>}
									</div>

									<div className="form-group mb-3">
										<label htmlFor="name" className="fw-semibold">
											Upload CV:
										</label>
										<input
											type="file"
											accept="application/pdf"
											placeholder="Enter your phone number"
											className="form-control"
											{...register('file', {
												required: 'CV is required',
											})}
										/>
										{errors.file && <div className="form-error-message">{errors.file.message}</div>}
									</div>

									<div className="mb-3">
										<GoogleReCaptcha onVerify={(token) => handleCaptchaChange(token)} />
									</div>
								</div>
							</Modal.Body>
							<Modal.Footer>
								<button
									type="button"
									className="fs-18 lh-40 btn-gradient btn-gradient-black-silver position-relative hover overflow-hidden text-white px-4 py-2 radius-12 d-inline-flex ms-2"
									onClick={handleClose}
								>
									<span className="text">Cancel</span>
								</button>
								<button
									type="submit"
									className="fs-18 lh-40 btn-gradient btn-gradient-blue-light-blue position-relative hover overflow-hidden text-white px-4 py-2 radius-12 d-inline-flex"
								>
									<span className="text">Submit</span>
								</button>
							</Modal.Footer>
						</form>
					</GoogleReCaptchaProvider>
				</Modal>
			</div>
		</>
	);
};

export async function getServerSideProps(params) {
	try {
		const siteSetting = await axios
			.get(apiUrl + '/api/siteSetting')
			.then((response) => {
				return response.data.data;
			})
			.catch((error) => {
				return null;
			});

		const jobDetails = await axios
			.get(apiUrl + '/api/jobDetail?slug=' + params.query.slug)
			.then((response) => {
				// console.log(response.data.data);
				return response.data.data;
			})
			.catch((error) => {
				return null;
			});
		return {
			props: {
				siteSetting: siteSetting,
				jobDetails: jobDetails,
				loaded: true,
			},
		};
	} catch (error) {
		return {
			props: {
				siteSetting: null,
				jobDetails: null,
				loaded: true,
			},
		};
	}
}

export default JobDetailsPage;
